import MDSpinner from "react-md-spinner";
import "./index.css";
import { useContext, useEffect, useRef } from "react";
import Mp3ControllerContext from "../../../../../Util/contexts/Mp3ControllerContext";

const SystemAudioVisualizer = ({ appState, applicationError }) => {
  const circleRef = useRef(null);
  const animationFrameRef = useRef(null);
  const { audioAnalyzer } = useContext(Mp3ControllerContext);

  useEffect(() => {
    if (!audioAnalyzer) {
      if (circleRef.current) {
        circleRef.current.style.transform = `translate(-50%, -50%) scale(1)`;
      }
      return;
    }

    const frequencyData = new Uint8Array(audioAnalyzer.frequencyBinCount);

    const animate = () => {
      audioAnalyzer.getByteFrequencyData(frequencyData);
      const avg =
        frequencyData.reduce((sum, val) => sum + val, 0) / frequencyData.length;

      const scale = 1 + Math.min(avg / 128, 0.5); // scale between 1 and 2
      if (circleRef.current) {
        circleRef.current.style.transform = `translate(-50%, -50%) scale(${scale})`;
      }

      animationFrameRef.current = requestAnimationFrame(animate);
    };

    animationFrameRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationFrameRef.current);
    };
  }, [audioAnalyzer]);

  let stateText = "";

  switch (appState) {
    case "transcribingUserResponse":
      stateText = "Transcribing Your Response";
      break;
    case "gettingSystemResponse":
      stateText = "Getting Patient Response";
      break;
    case "GeneratingAudioForSystemResponse":
      stateText = "Generating Audio Response";
      break;
    case "PlayingSystemResponse":
      stateText = "Speaking";
      break;
    default:
      stateText = "";
  }

  if (applicationError) {
    stateText = "An Error Occurred";
  }

  return (
    <div className="systemAudioVisualizerWrapper">
      <div className="systemAudioVisualizerContainer">
        <div className="systemAudioVisualizerCircle" ref={circleRef} />
      </div>
      <div className="systemAudioVisualizerStateText">
        {appState !== "PlayingSystemResponse" && !applicationError && (
          <MDSpinner singleColor={"#0283BE"} size={16} />
        )}
        <p>{stateText}</p>
      </div>
    </div>
  );
};

export default SystemAudioVisualizer;
